import { createContext, useContext, useState, useCallback } from 'react'
import Confetti from 'react-confetti'

const ConfettiContext = createContext(null)

export function ConfettiProvider({ children }) {
  const [isActive, setIsActive] = useState(false)
  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight })

  const triggerConfetti = useCallback(() => {
    setDimensions({ width: window.innerWidth, height: window.innerHeight })
    setIsActive(true)
  }, [])

  const handleComplete = useCallback(() => {
    setIsActive(false)
  }, [])

  return (
    <ConfettiContext.Provider value={{ triggerConfetti }}>
      {children}
      {isActive && (
        <Confetti
          width={dimensions.width}
          height={dimensions.height}
          numberOfPieces={400}
          gravity={0.2}
          wind={0}
          initialVelocityY={15}
          tweenDuration={3000}
          recycle={false}
          onConfettiComplete={handleComplete}
          style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999, pointerEvents: 'none' }}
        />
      )}
    </ConfettiContext.Provider>
  )
}

export function useConfetti() {
  const context = useContext(ConfettiContext)
  if (!context) {
    throw new Error('useConfetti must be used within ConfettiProvider')
  }
  return context
}
